const medilinePlans = [
    { id: 1, name: 'Classic', price:2300 },
    { id: 2, name: 'Plus', price:3600 },
    { id: 3, name: 'Premium', price:6000 }
 ];
 
 export default medilinePlans;
 